export default "__VITE_ASSET__BQOsNDa4__"